export default __webpack_public_path__ + "static/media/icon-audio-on.75460b82.svg";